/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var FlagOutlineIcon = function FlagOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12275_100398)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 -6H-7V63H31V-6ZM-8 -7V64H32V-7H-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7C4 5.34315 5.34315 4 7 4H11C12.1046 4 13 4.89543 13 6H17.5573C18.9536 6 19.9201 7.39439 19.4302 8.70182L18.3816 11.5L19.4302 14.2982C19.9201 15.6056 18.9536 17 17.5573 17H13C11.8954 17 11 16.1046 11 15H6L6 20H4V13V7ZM11 13V8V6H7C6.44772 6 6 6.44772 6 7V13H11ZM13 8V13V15L17.5573 15L16.5088 12.2018C16.3392 11.7493 16.3392 11.2507 16.5088 10.7982L17.5573 8H13Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12275_100398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
export default FlagOutlineIcon;